module.exports = __webpack_public_path__ + "img/idi-2.5a7ee6ff.jpg";